var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-container"},[_c('div',{staticClass:"input-dv"},[_c('el-row',[_vm._v(" 查找面板 ")])],1),_c('div',{staticClass:"save-plan-dv"},[_vm._v("已保存方案")])])}
var staticRenderFns = []

export { render, staticRenderFns }